import React from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/user-panel';
import './header.scss';
import { Template } from 'devextreme-react/core/template';
import LogoLight from '../../assets/asafeLogoLight.png'
import LogoDark from '../../assets/asafeLogoDark.png'
import TopNavigationMenu from 'components/top-navigation-menu/top-navigation-menu';
import { useTheme } from 'contexts/theme';

export default function Header({ menuToggleEnabled, title, toggleMenu, selectedItemChanged }) {
  const { theme } = useTheme();
  const Logo = theme === 'dark' ? LogoDark : LogoLight;

  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'} id='test'>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
          className={'header-title2'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          cssClass={'header-title2'}
          className={'header-title2'}
        >
          <div className="redlore-logo">
            <img src={Logo} className={'redlore-logo'} alt='A-SAFE'/>
          </div>
        </Item>

        <Item location="before" cssClass="nav-container">
          <TopNavigationMenu selectedItemChanged={selectedItemChanged} />
        </Item>
        
        <Item
          location={'after'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>
        <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template>
      </Toolbar>
    </header>
)}
